var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2C11.25 1.58579 11.5858 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75C11.5858 2.75 11.25 2.41421 11.25 2Z",
    fill: "#afb5cb"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.10012 2.39808C9.24928 2.7845 9.05695 3.21868 8.67053 3.36785C8.52909 3.42245 8.38933 3.48042 8.25134 3.54168C7.87275 3.70975 7.4296 3.5391 7.26154 3.16051C7.09347 2.78193 7.26412 2.33878 7.64271 2.17071C7.80321 2.09946 7.9658 2.03201 8.13034 1.96849C8.51677 1.81932 8.95095 2.01166 9.10012 2.39808ZM5.64824 4.2408C5.93391 4.54075 5.92232 5.01549 5.62237 5.30115C5.5127 5.40559 5.40559 5.5127 5.30115 5.62237C5.01549 5.92232 4.54075 5.93391 4.2408 5.64824C3.94085 5.36258 3.92927 4.88785 4.21493 4.5879C4.3362 4.46056 4.46056 4.3362 4.5879 4.21493C4.88785 3.92927 5.36258 3.94085 5.64824 4.2408ZM3.16051 7.26154C3.5391 7.42961 3.70975 7.87276 3.54168 8.25134C3.48042 8.38933 3.42245 8.52909 3.36785 8.67053C3.21868 9.05695 2.7845 9.24928 2.39808 9.10012C2.01166 8.95095 1.81932 8.51677 1.96849 8.13035C2.03201 7.9658 2.09946 7.80321 2.17071 7.64271C2.33878 7.26412 2.78193 7.09347 3.16051 7.26154Z",
    fill: "#afb5cb"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M12 8.25C12.4142 8.25 12.75 8.58579 12.75 9V12.25H16C16.4142 12.25 16.75 12.5858 16.75 13C16.75 13.4142 16.4142 13.75 16 13.75H12C11.5858 13.75 11.25 13.4142 11.25 13V9C11.25 8.58579 11.5858 8.25 12 8.25Z",
    fill: "#afb5cb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/History.c893e1c390e1d940688a28fec691e123.svg";
export { ForwardRef as ReactComponent };